import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';

import { MyApp } from './app.component';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

//HTTP
import { HttpModule } from '@angular/http';
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { FileTransfer } from '@ionic-native/file-transfer';
//Provider
import { ServiceSidemenuProvider } from '../providers/service-sidemenu/service-sidemenu';
import { ServiceApiProvider } from '../providers/service-api/service-api';
import { ServiceGvariableProvider } from '../providers/service-gvariable/service-gvariable';

//Component
import { ComponentHeaderPage } from '../pages/component-header/component-header';

//Page
import { A01LoginPage } from '../pages/a01-login/a01-login';
import { B01DashboardPage } from '../pages/b01-dashboard/b01-dashboard';
import { B02UserManagementPage } from '../pages/b02-user-management/b02-user-management';
import { B02aCompanyAddPage } from '../pages/b02a-company-add/b02a-company-add';
import { B02bCompanyInfoPage } from '../pages/b02b-company-info/b02b-company-info';
import { B02cUserListPage } from '../pages/b02c-user-list/b02c-user-list';
import { B02dUserAddPage } from '../pages/b02d-user-add/b02d-user-add';
import { B02eUserInfoPage } from '../pages/b02e-user-info/b02e-user-info';
import { B02iCustomerManagementPage } from '../pages/b02i-customer-management/b02i-customer-management';
import { B02iaCustomerAddPage } from '../pages/b02ia-customer-add/b02ia-customer-add';
import { B02ibCustomerInfoPage } from '../pages/b02ib-customer-info/b02ib-customer-info';
import { B02icCustomerUserListPage } from '../pages/b02ic-customer-user-list/b02ic-customer-user-list';
import { B02idCustomerUserAddPage } from '../pages/b02id-customer-user-add/b02id-customer-user-add';
import { B02ieCustomerUserInfoPage } from '../pages/b02ie-customer-user-info/b02ie-customer-user-info';
import { B03CardManagementPage } from '../pages/b03-card-management/b03-card-management';
import { B03aCardAddPage } from '../pages/b03a-card-add/b03a-card-add';
import { B03bCardInfoPage } from '../pages/b03b-card-info/b03b-card-info';
import { B04InventoryManagementPage } from '../pages/b04-inventory-management/b04-inventory-management';
import { B04aInventoryInfoPage } from '../pages/b04a-inventory-info/b04a-inventory-info';
import { B04bInventoryAddPage } from '../pages/b04b-inventory-add/b04b-inventory-add';
import { B04cInventoryPage } from '../pages/b04c-inventory/b04c-inventory';
import { B04dInventoryLevelInfoPage } from '../pages/b04d-inventory-level-info/b04d-inventory-level-info';
import { B05PurchaseOrderPage } from '../pages/b05-purchase-order/b05-purchase-order';
import { B05aPurchaseInfoPage } from '../pages/b05a-purchase-info/b05a-purchase-info';
import { B05bPurchaseAddPage } from '../pages/b05b-purchase-add/b05b-purchase-add';
import { B06SupplierPage } from '../pages/b06-supplier/b06-supplier';
import { B06aSupplierInfoPage } from '../pages/b06a-supplier-info/b06a-supplier-info';
import { B06bSupplierAddPage } from '../pages/b06b-supplier-add/b06b-supplier-add';
import { B07InvoicePage } from '../pages/b07-invoice/b07-invoice';
import { B07aInvoiceInfoPage } from '../pages/b07a-invoice-info/b07a-invoice-info';
import { B07bInvoiceAddPage } from '../pages/b07b-invoice-add/b07b-invoice-add';
import { B07cInvoicePaymentPage } from '../pages/b07c-invoice-payment/b07c-invoice-payment';
import { B08ReportManagementPage } from '../pages/b08-report-management/b08-report-management';
import { B08aAgedBalancePage } from '../pages/b08a-aged-balance/b08a-aged-balance';
import { B08bClientBillingPage } from '../pages/b08b-client-billing/b08b-client-billing';
import { B08cFleetTransactionPage } from '../pages/b08c-fleet-transaction/b08c-fleet-transaction';
import { B08dOutstandingInvoicePage } from '../pages/b08d-outstanding-invoice/b08d-outstanding-invoice';
import { B08eInvoiceSummaryPage } from '../pages/b08e-invoice-summary/b08e-invoice-summary';
import { B08fSalesDetailPage } from '../pages/b08f-sales-detail/b08f-sales-detail';
import { B08gShiftSalesPage } from '../pages/b08g-shift-sales/b08g-shift-sales';
import { B08hInventoryPage } from '../pages/b08h-inventory/b08h-inventory';
import { B08iInventoryMovementPage } from '../pages/b08i-inventory-movement/b08i-inventory-movement';
import { B08jFuelPricePage } from '../pages/b08j-fuel-price/b08j-fuel-price';
import { B08kPoPage } from '../pages/b08k-po/b08k-po';
import { B08lGoodReceivePage } from '../pages/b08l-good-receive/b08l-good-receive';
import { B08mWantokPointPage } from '../pages/b08m-wantok-point/b08m-wantok-point';
import { B08nWantokGiftcardSalesDetailPage } from '../pages/b08n-wantok-giftcard-sales-detail/b08n-wantok-giftcard-sales-detail'; //[TCG:28/07/2020:CR/MB/20-02]:Added
import { B09SettingPage } from '../pages/b09-setting/b09-setting';
import { B09aProfileInfoPage } from '../pages/b09a-profile-info/b09a-profile-info';
import { B09bBranchInfoPage } from '../pages/b09b-branch-info/b09b-branch-info';
import { B09cCorporateInfoPage } from '../pages/b09c-corporate-info/b09c-corporate-info';
import { B09dSettingInfoPage } from '../pages/b09d-setting-info/b09d-setting-info';

import { B10LogoutPage } from '../pages/b10-logout/b10-logout';
import { B11AlertEventPage } from '../pages/b11-alert-event/b11-alert-event';
import { B11PaymentTypeManagementPage } from '../pages/b11-payment-type-management/b11-payment-type-management';
import { B11aPaymentTypeAddPage } from '../pages/b11a-payment-type-add/b11a-payment-type-add';
import { B11bPaymentTypeInfoPage } from '../pages/b11b-payment-type-info/b11b-payment-type-info';
import { B11cPaymentTypeSubListPage } from '../pages/b11c-payment-type-sub-list/b11c-payment-type-sub-list';
import { B11dPaymentTypeSubListAddPage } from '../pages/b11d-payment-type-sub-list-add/b11d-payment-type-sub-list-add';
import { B11ePaymentTypeSubListInfoPage } from '../pages/b11e-payment-type-sub-list-info/b11e-payment-type-sub-list-info';

import { IonicSelectableModule } from 'ionic-selectable';
@NgModule({
  declarations: [
    MyApp,
    A01LoginPage,
    B01DashboardPage,
    B02UserManagementPage,
    B02aCompanyAddPage,
    B02bCompanyInfoPage,
    B02cUserListPage,
    B02dUserAddPage,
    B02eUserInfoPage,
    B02iCustomerManagementPage,
    B02iaCustomerAddPage,
    B02ibCustomerInfoPage,
    B02icCustomerUserListPage,
    B02idCustomerUserAddPage,
    B02ieCustomerUserInfoPage,
    B03CardManagementPage,
    B03aCardAddPage,
    B03bCardInfoPage,
    B04InventoryManagementPage,
    B04aInventoryInfoPage,
    B04bInventoryAddPage,
    B04cInventoryPage,
    B04dInventoryLevelInfoPage,
    B05PurchaseOrderPage,
    B05aPurchaseInfoPage,
    B05bPurchaseAddPage,
    B06SupplierPage,
    B06aSupplierInfoPage,
    B06bSupplierAddPage,
    B07InvoicePage,
    B07aInvoiceInfoPage,
    B07bInvoiceAddPage,
    B07cInvoicePaymentPage,
    B08ReportManagementPage,
    B08aAgedBalancePage,
    B08bClientBillingPage,
    B08cFleetTransactionPage,
    B08dOutstandingInvoicePage,
    B08eInvoiceSummaryPage,
    B08fSalesDetailPage,
    B08gShiftSalesPage,
    B08hInventoryPage,
    B08iInventoryMovementPage,
    B08jFuelPricePage,
    B08kPoPage,
    B08lGoodReceivePage,
    B08mWantokPointPage,
    B08nWantokGiftcardSalesDetailPage, //[TCG:28/07/2020:CR/MB/20-02]:Added
    B09SettingPage,
    B09aProfileInfoPage,
    B09bBranchInfoPage,
    B09cCorporateInfoPage,
    B09dSettingInfoPage,
    B10LogoutPage,
    B11AlertEventPage,
    B11PaymentTypeManagementPage,
    B11aPaymentTypeAddPage,
    B11bPaymentTypeInfoPage,
    B11cPaymentTypeSubListPage,
    B11dPaymentTypeSubListAddPage,
    B11ePaymentTypeSubListInfoPage,
    ComponentHeaderPage
  ],
  imports: [
    BrowserModule,
    IonicSelectableModule,
    IonicModule.forRoot(MyApp, {}, {
      links: [
       { component: A01LoginPage, name: 'Login', segment: 'login' },
       { component: B01DashboardPage, name: 'Dashboard', segment: 'dashboard' },
       { component: B02UserManagementPage, name: 'User', segment: 'usermanagement' },
       { component: B02aCompanyAddPage, name: 'AddBranch', segment: 'addbranch' },
       { component: B02bCompanyInfoPage, name: 'BranchInfo', segment: 'branchinfo' },
       { component: B02cUserListPage, name: 'UserList', segment: 'userlist' },
       { component: B02dUserAddPage, name: 'UserAdd', segment: 'useradd' },
       { component: B02eUserInfoPage, name: 'UserInfo', segment: 'userinfo' },
       { component: B02iCustomerManagementPage, name: 'Customer', segment: 'customermanagement' },
       { component: B02iaCustomerAddPage, name: 'AddCustomer', segment: 'addcustomer' },
       { component: B02ibCustomerInfoPage, name: 'CustomerInfo', segment: 'customerinfo' },
       { component: B02icCustomerUserListPage, name: 'CustomerUserList', segment: 'customeruserlist' },
       { component: B02idCustomerUserAddPage, name: 'CustomerUserAdd', segment: 'customeruseradd' },
       { component: B02ieCustomerUserInfoPage, name: 'CustomerUserInfo', segment: 'customeruserinfo' },
       { component: B03CardManagementPage, name: 'Card', segment: 'cardmanagement' },
       { component: B03aCardAddPage, name: 'AddCard', segment: 'addcard' },
       { component: B03bCardInfoPage, name: 'CardInfo', segment: 'cardinfo' },
       { component: B04InventoryManagementPage, name: 'Inventory', segment: 'inventorymanagement' },
       { component: B04aInventoryInfoPage, name: 'InventoryInfo', segment: 'inventoryinfo' },
       { component: B04bInventoryAddPage, name: 'InventoryAdd', segment: 'inventoryadd' },
       { component: B04cInventoryPage, name: 'Inventory', segment: 'inventory' },
       { component: B04dInventoryLevelInfoPage, name: 'InventoryLevelInfo', segment: 'inventorylevelinfo' },
       { component: B05PurchaseOrderPage, name: 'PurchaseOrder', segment: 'purchaseorder' },
       { component: B05aPurchaseInfoPage, name: 'PurchaseInfo', segment: 'purchaseinfo' },
       { component: B05bPurchaseAddPage, name: 'NewPurchase', segment: 'newpurchase' },
       { component: B06SupplierPage, name: 'Supplier', segment: 'supplier' },
       { component: B06aSupplierInfoPage, name: 'SupplierInfo', segment: 'supplierinfo' },
       { component: B06bSupplierAddPage, name: 'NewSupplier', segment: 'newsupplier' },
       { component: B07InvoicePage, name: 'Invoice', segment: 'invoice' },
       { component: B07aInvoiceInfoPage, name: 'InvoiceInfo', segment: 'invoiceinfo' },
       { component: B07bInvoiceAddPage, name: 'InvoiceAdd', segment: 'newinvoice' },
       { component: B07cInvoicePaymentPage, name: 'InvoicePayment', segment: 'invoicepayment' },
       { component: B08ReportManagementPage, name: 'Report', segment: 'reportmanagement' },
       { component: B08aAgedBalancePage, name: 'AgedBalance', segment: 'agedbalancereport' },
       { component: B08bClientBillingPage, name: 'ClientBilling', segment: 'clientbillingreport' },
       { component: B08cFleetTransactionPage, name: 'FleetTransaction', segment: 'fleettransactionreport' },
       { component: B08dOutstandingInvoicePage, name: 'OutstandingInvoice', segment: 'outstandinginvoicereport' },
       { component: B08eInvoiceSummaryPage, name: 'InvoiceSummary', segment: 'invoicesummaryreport' },
       { component: B08fSalesDetailPage, name: 'SalesDetail', segment: 'salesdetailreport' },
       { component: B08gShiftSalesPage, name: 'ShiftSales', segment: 'shiftsalesreport' },
       { component: B08hInventoryPage, name: 'Inventory', segment: 'inventoryreport' },
       { component: B08iInventoryMovementPage, name: 'InventoryMovement', segment: 'inventorymovementreport' },
       { component: B08jFuelPricePage, name: 'FuelPrice', segment: 'fuelpricereport' },
       { component: B08kPoPage, name: 'PO', segment: 'poreport' },
       { component: B08lGoodReceivePage, name: 'GoodReceive', segment: 'goodreceivereport' },
       { component: B08mWantokPointPage, name: 'WantokPoint', segment: 'wantokpointreport' },
       { component: B08nWantokGiftcardSalesDetailPage, name: 'WantokGiftCardSalesDetail', segment: 'wantokgiftcardsalesdetailreport' }, //[TCG:28/07/2020:CR/MB/20-02]:Added
       { component: B09SettingPage, name: 'Setting', segment: 'setting' },
       { component: B09aProfileInfoPage, name: 'ProfileInfo', segment: 'profileinfo' },
       { component: B09bBranchInfoPage, name: 'BranchInfo', segment: 'branchinfo' },
       { component: B09cCorporateInfoPage, name: 'CorporateInfo', segment: 'corporateInfo' },
       { component: B09dSettingInfoPage, name: 'SettingInfo', segment: 'settingInfo' },
       { component: B10LogoutPage, name: 'Logout', segment: 'logout' },
       { component: B11AlertEventPage, name: 'AlertEvent', segment: 'alert' },
       { component: B11PaymentTypeManagementPage, name: 'PaymentType', segment: 'paymentType' },
       { component: B11aPaymentTypeAddPage, name: 'PaymentTypeAdd', segment: 'paymentTypeAdd' },
       { component: B11bPaymentTypeInfoPage, name: 'PaymentTypeInfo', segment: 'PaymentTypeInfo' },
       { component: B11cPaymentTypeSubListPage, name: 'PaymentSubType', segment: 'PaymentSubType' },
       { component: B11dPaymentTypeSubListAddPage, name: 'PaymentSubTypeAdd', segment: 'PaymentSubTypeAdd' },
       { component: B11ePaymentTypeSubListInfoPage, name: 'PaymentSubTypeInfo', segment: 'PaymentSubTypeInfo' },
     ]
    }),
    HttpModule,
    HttpClientModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    A01LoginPage,
    B01DashboardPage,
    B02UserManagementPage,
    B02aCompanyAddPage,
    B02bCompanyInfoPage,
    B02cUserListPage,
    B02dUserAddPage,
    B02eUserInfoPage,
    B02iCustomerManagementPage,
    B02iaCustomerAddPage,
    B02ibCustomerInfoPage,
    B02icCustomerUserListPage,
    B02idCustomerUserAddPage,
    B02ieCustomerUserInfoPage,
    B03CardManagementPage,
    B03aCardAddPage,
    B03bCardInfoPage,
    B04InventoryManagementPage,
    B04aInventoryInfoPage,
    B04bInventoryAddPage,
    B04cInventoryPage,
    B04dInventoryLevelInfoPage,
    B05PurchaseOrderPage,
    B05aPurchaseInfoPage,
    B05bPurchaseAddPage,
    B06SupplierPage,
    B06aSupplierInfoPage,
    B06bSupplierAddPage,
    B07InvoicePage,
    B07aInvoiceInfoPage,
    B07bInvoiceAddPage,
    B07cInvoicePaymentPage,
    B08ReportManagementPage,
    B08aAgedBalancePage,
    B08bClientBillingPage,
    B08cFleetTransactionPage,
    B08dOutstandingInvoicePage,
    B08eInvoiceSummaryPage,
    B08fSalesDetailPage,
    B08gShiftSalesPage,
    B08hInventoryPage,
    B08iInventoryMovementPage,
    B08jFuelPricePage,
    B08kPoPage,
    B08lGoodReceivePage,
    B08mWantokPointPage,
    B08nWantokGiftcardSalesDetailPage, //[TCG:28/07/2020:CR/MB/20-02]:Added
    B09SettingPage,
    B09aProfileInfoPage,
    B09bBranchInfoPage,
    B09cCorporateInfoPage,
    B09dSettingInfoPage,
    B10LogoutPage,
    B11AlertEventPage,
    B11PaymentTypeManagementPage,
    B11aPaymentTypeAddPage,
    B11bPaymentTypeInfoPage,
    B11cPaymentTypeSubListPage,
    B11dPaymentTypeSubListAddPage,
    B11ePaymentTypeSubListInfoPage,
    ComponentHeaderPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler}, 
    ServiceSidemenuProvider,
    ServiceApiProvider,
    ServiceGvariableProvider,
    FileTransfer
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts